<template>
  <v-card color="#fafafa">
    <v-img
      class="primary"
      :aspect-ratio="2.1"
      :src="thumbnail" />
    <div class="px-4 py-3" style="display: flex; align-items: center; overflow: hidden;">
      <div :style="`max-width: ${cta ? 80 : 95}%`">
        <p class="body-2 font-weight-bold pa-0 ma-0">{{ title }}</p>
        <p class="body-2 pa-0 ma-0 trim-oneline">{{ description }}</p>
        <p class="body-2 grey--text pa-0 ma-0 trim-oneline">{{ domain }}</p>
      </div>
      <v-spacer />
      <v-btn v-if="cta" color="white" class="text-none">
        {{ cta }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'FbWebLink',
  injectModels: ['Store'],
  props: {
    url: String,
    cta: String
  },
  computed: {
    page() {
      return this.Store.getWebPage(this.url)
    },
    thumbnail() {
      return this.page ? this.page.thumbnail : ''
    },
    title() {
      return this.page ? (this.page.title || '(blank)') : '(ERROR: Invalid URL!)'
    },
    description() {
      return this.page ? this.page.description : ''
    },
    domain() {
      if (this.page == null)
        return ''
      return this.url.substr('https://'.length).split('/')[0]
    }
  }
}
</script>